<i18n lang="yaml">
en:
  teaserButton1: 'Create account'
  teaserButton2: 'Go to panel'
  sectionTitle: 'Selectel cloud conforms to&nbsp;Law No. 152-FZ'
  sectionSubtitle: "Russian legislation requires companies to&nbsp;collect, store, and process personal data in&nbsp;accordance with Law No. 152-FZ. By&nbsp;hosting your projects at&nbsp;Selectel, you will be&nbsp;able to&nbsp;comply with the
                <a href='https://kb.selectel.com/docs/selectel-cloud-platform/main-services/cloud_server_152fz/' target='_blank' rel='noopener noreferrer'>part of the law</a>
                dealing with&nbsp;IT infrastructure and physical data security."
  sectionButton: 'Read more about Law No. 152-FZ'
  ctaTitle1: 'Find even more fixed configurations in&nbsp;the Control Panel'
  ctaTitle2: 'Not sure how to&nbsp;migrate your services to&nbsp;Selectel?'
  ctaTitle3: 'Ready to start?'
  ctaDescription: 'We&nbsp;can help by&nbsp;evaluating your project, defining the requirements, and performing the migration. This is&nbsp;free until the 1th of&nbsp;August.'
  ctaButton1: 'Start Using'
  ctaButton2: 'Learn More about the Special Offer'
ru:
  teaserButton1: 'Создать аккаунт'
  teaserButton2: 'Перейти в панель'
  sectionTitle: 'Облако Selectel соответствует&nbsp;152-ФЗ'
  sectionSubtitle: "Российское законодательство требует, чтобы компании собирали, хранили и&nbsp;обрабатывали персональные данные в&nbsp;соответствии с&nbsp;152-ФЗ. Размещая свои проекты в&nbsp;Selectel, вы&nbsp;сможете соблюдать
                <a
                  href='https://kb.selectel.ru/docs/selectel-cloud-platform/main-services/cloud_server_152fz/'
    target='_blank' rel='noopener noreferrer'
    >часть требований закона</a>, которые касаются IT-инфраструктуры и&nbsp;физической безопасности данных."
  sectionButton: 'Подробнее про 152-ФЗ'
  ctaTitle1: 'Еще больше фиксированных конфигураций доступно в панели'
  ctaTitle2: 'Не&nbsp;знаете, как перевезти свои сервисы в&nbsp;Selectel?'
  ctaTitle3: 'Готовы начать использовать?'
  ctaDescription: 'Мы&nbsp;поможем&nbsp;&mdash; оценим проект, сформируем требования и&nbsp;осуществим перенос. До 1&nbsp;августа&nbsp;2021 года сделаем это бесплатно.'
  ctaButton1: 'Начать использовать'
  ctaButton2: 'Узнать подробности акции'
</i18n>

<template>
  <div class="page">
    <teaser
      :svg-background="require('~/assets/images/components/teaser/background/cloud.svg?inline').default"
      :title="pageTitle"
      :teaser="teaser"
    >
      <template #buttons>
        <a
          href="https://my.selectel.ru/registration?destination=/vpc/servers"
          class="btn btn--lg"
          v-html="$t('teaserButton1')"
        ></a>
        <a
          href="https://my.selectel.ru/registration?destination=/vpc/servers"
          class="btn btn--lg"
          v-html="$t('teaserButton2')"
        ></a>
      </template>
    </teaser>

    <servers-configurations
      :microdata="{
        title: pageTitle,
        description: $metaInfo.meta.find(item => item.name === 'description').content
      }"
    ></servers-configurations>

    <call-to-action
      :title="$t('ctaTitle1')"
      v-lazy-background :lazy-background="require('~/assets/images/components/common/call-to-action/services-cloud.jpg')"
    >
      <a
        href="https://my.selectel.ru/registration?destination=/vpc/servers"
        class="btn btn--lg"
        v-html="$t('ctaButton1')"
      ></a>
    </call-to-action>

    <configurator></configurator>

    <values
      v-if="hasAdditionalValues"
      :values="additionalValues"
      class="pt-4"
    ></values>

    <call-to-action
      :title="$t('ctaTitle2')"
      :description="$t('ctaDescription')"
      v-lazy-background :lazy-background="require('~/assets/images/components/common/call-to-action/services-cloud-2.jpg')"
    >
      <nuxt-link
        :to="localePath('/onboarding/')"
        class="btn btn--lg"
        v-html="$t('ctaButton2')"
      ></nuxt-link>
    </call-to-action>

    <volumes-configurations></volumes-configurations>

    <network></network>

    <zones></zones>

    <s-section
      type="bordered"
      :title="$t('sectionTitle')"
      :subtitle="$t('sectionSubtitle')"
    >
      <div class="row">
        <div class="col-xl-9 ml-auto">
          <nuxt-link
            :to="localePath('/solutions/pdps/')"
            class="btn btn--dark btn--lg"
            v-html="$t('sectionButton')"
          ></nuxt-link>
        </div>
      </div>
    </s-section>

    <values
      v-if="hasValues"
      :values="values"
    ></values>

    <call-to-action
      :title="$t('ctaTitle3')"
      v-lazy-background :lazy-background="require('~/assets/images/components/common/call-to-action/services-cloud.jpg')"
    >
      <a
        href="https://my.selectel.ru/registration?destination=/vpc/servers"
        class="btn btn--lg"
        v-html="$t('teaserButton2')"
      ></a>
    </call-to-action>

    <products
      v-if="hasAdditionalServices"
      :products="additionalServices"
    ></products>
  </div>
</template>

<script>
import PageComponents from '~/mixins/page/page-components'
import PageSeo from '~/mixins/page/page-seo'

import Teaser from '~/components/teaser/Teaser'
import ServersConfigurations from '~/components/configurations/CloudServersConfigurations'
import Configurator from '~/components/configurators/CloudServersConfigurator'
import VolumesConfigurations from '~/components/configurations/CloudServersVolumesConfigurations'
import Network from '~/components/single/cloud/CloudServersNetwork'
import Zones from '~/components/single/cloud/CloudZones'
import Values from '~/components/common/values/Values'
import CallToAction from '~/components/common/call-to-action/CallToAction'
import Products from '~/components/common/products/Products'

export default {
  async asyncData(ctx) {
    const {app, $http, error} = ctx

    try {
      const page = await $http.$get(`${app.wp}/v2/pages/slug/servers`)

      return {page}
    } catch (err) {
      error(err)
    }
  },
  name: 'Servers',
  components: {
    Teaser,
    ServersConfigurations,
    Configurator,
    VolumesConfigurations,
    Network,
    Zones,
    Values,
    CallToAction,
    Products
  },
  mixins: [
    PageComponents,
    PageSeo
  ]
}
</script>